export const notifications = {
  successDataUpdate: 'Data successfully updated.',
  errorOnDataUpdate: 'An error occurred while updating the data.',
  waitResponseIn24Hours:
    'Wait for a response to your invitation within 72 hours.',
  workItemIsCanceled: 'The invitation was withdrawn.',
  notificationDeleted: 'Notification deleted.',
  noNotifications: 'You have no notifications.',
  workInviteRejected: 'Invitation rejected.',
  workStartOnArtistArrivalConfirm:
    'Work will begin once the club confirms your presence at the workplace.',
  giveResponseFormWorkItem:
    'Respond to the invitation within 72 hours. After 72 hours, the invitation will be deleted.',
  generalError: 'Something went wrong, try again later.',
  passwordReseted: 'Password reset.',
  languageSwitched: 'Language changed.',
  invitationExpired: 'Invitation expired.',
  linkIsCopied: 'Link copied.',
  accountIsVisible: 'Account will be visible in search.',
  hiringEnabled: 'Artist recruitment is open.',
  hiringDisabled: 'Artist recruitment is closed.',
  rejectedForReason: 'Rejected for reason {content}.',
  profileDeleted: 'Profile deleted.',
  accountHiddenFromSearch:
    'Account is hidden and no longer appears in artist searches.',
  registerRequestSended: 'Registration request sent.',
  notFoundNotifications: 'You have no notifications.',
  lastWorkDaySeted: 'Last work day set.'
};
